import React, { Component } from 'react'
import ButtonGroup from 'react-bootstrap/lib/ButtonGroup'
import Button from 'react-bootstrap/lib/Button'
import OverlayTrigger from 'react-bootstrap/lib/OverlayTrigger'
import Tooltip from 'react-bootstrap/lib/Tooltip'

class PersonalDashButtonGroup extends Component {
    constructor(props) {
        super(props)
    }

    onCalendarClick = () => {
        this.props.onDisplayChange('calendar')
    }

    onListClick = () => {
        this.props.onDisplayChange('list')
    }

    render() {
        const { display } = this.props
        return (
            <ButtonGroup>
                <OverlayTrigger placement="bottom" delayShow={300} delayHide={150} overlay={<Tooltip id="tip-list-view">List view</Tooltip>}>
                    <Button onClick={this.onListClick} active={display === 'list'}>
                        <i className="fa fa-bars" aria-hidden="true"></i>
                    </Button>
                </OverlayTrigger>
                <OverlayTrigger placement="bottom" delayShow={300} delayHide={150} overlay={<Tooltip id="tip-calendar-view">Calendar view</Tooltip>}>
                    <Button onClick={this.onCalendarClick} active={display === 'calendar'}>
                        <i className="fa fa-calendar" aria-hidden="true"></i>
                    </Button>
                </OverlayTrigger>
            </ButtonGroup>
        )
    }
}

export default PersonalDashButtonGroup


// WEBPACK FOOTER //
// ./src/components/personal_dash_button_group.jsx